import React from "react";
import StudioAbout from "./StudioAbout";
import CollectionsShowcase from "./CollectionsShowcase";
import IndustryHoops from "./IndustryHoops";
import MfgTape from "./MfgTape";
import WhyRail from "./WhyRail";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import {
  ArrowRight, ArrowUpRight, MessageCircle, Phone, Mail,
  Sparkles, Factory, Shirt, BadgeCheck, Ruler, Layers, Zap, ShieldCheck,
  Store, Package, PartyPopper, Heart, Camera, Megaphone,
  PenTool, Printer, Flame, Scissors, Truck,
} from "lucide-react";
import { Reveal, Label, Display, PillLink } from "./ui";
import { IMG, COLLECTIONS, WHY, INDUSTRIES, PROCESS, CONTACT } from "./siteData";
import NewArrivals from "./NewArrivals";
import PremiumHero from "./PremiumHero";
import AboutPremium from "./AboutPremium";
import { StudioCTA } from "./StudioCTA";

const ICON = {
  Sparkles, Factory, Shirt, BadgeCheck, Ruler, Layers, Zap, ShieldCheck,
  Store, Package, PartyPopper, Heart, Camera, Megaphone,
  PenTool, Printer, Flame, Scissors, Truck,
};

// Hero image: put your own file at frontend/public/hero.jpg (falls back to HERO_FALLBACK).
const HERO_IMG = "/hero.jpg";
const HERO_FALLBACK = IMG.printedFolds;
const FADE = "linear-gradient(to right, transparent 0%, #000 30%)";

export default function Home() {
  return (
    <div data-testid="home-page">
      {/* 1 · Hero */}
      <PremiumHero />

      <NewArrivals variant="home" />
      <NewArrivals variant="home" kind="pattern" />

      {/* 2 · About Nayara Studio */}
      <StudioAbout />

      {/* 3 · Why Nayara Studio */}
      <WhyRail />

      {/* 4 · Manufacturing Excellence */}
      <MfgTape />

      {/* 5 · Industries We Serve */}
      <IndustryHoops />

      {/* 6 · Featured Product Collections */}
      <CollectionsShowcase />

      {/* 7 · Gallery preview */}
      {/* Gallery section hidden — remove "false &&" to show again */}
      {false && (
      <section className="py-16 lg:py-20 mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal className="flex flex-wrap items-end justify-between gap-4">
          <div><Label>Gallery</Label><Display className="mt-5 text-4xl sm:text-5xl">Our work, up close.</Display></div>
          <Link to="/gallery" className="text-sm tracking-wide text-[#1A1A1A] underline-offset-4 hover:text-[#B89B72] hover:underline" data-testid="gallery-viewall">View gallery</Link>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
          {[IMG.printedFolds, IMG.kurtiRedStreet, IMG.eventGala, IMG.studioBlack, IMG.printMachine, IMG.weddingArch].map((img, i) => (
            <Reveal key={i} delay={(i % 6) * 0.05}>
              <Link to="/gallery" className="group block overflow-hidden rounded-md" data-testid={`home-gallery-${i}`}>
                <img src={img} alt="Nayara work" className="aspect-square w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      )}

      {/* 8 · Enquiry CTA */}
      <StudioCTA />
    </div>
  );
}